import { ReactNode } from "react";
import cn from "classnames";
import styles from "./TitlePage.module.scss";

import iconHappy from "~/assets/img/happy-emoji.jpg";

interface TitlePageNewProps {
  name: string;
  number: string;
  description?: string;
  descriptionNode?: ReactNode;
  classNameDescription?: string;
  isRenderIconHappy?: boolean;
}

export const TitlePageNew = ({
  name,
  number,
  description,
  descriptionNode,
  classNameDescription,
  isRenderIconHappy = false,
}: TitlePageNewProps) => (
  <div className={styles.container}>
    <div className={styles.containerTitle}>
      <p className={styles.number}>{number}</p>
      <h2 className={styles.name}>
        <span>{name}</span>
        {isRenderIconHappy && (
          <img src={iconHappy} alt="" className={styles.iconHappyEmoji} />
        )}
      </h2>
    </div>

    {(description || descriptionNode) && (
      <div className={cn(styles.description, classNameDescription)}>
        {description ? <p>{description}</p> : descriptionNode}
      </div>
    )}
  </div>
);
